import('./collapse_card.css')

export default function CollapseCard(opts = {}){

    let {title_options = {}, content_options = {}, is_open = false, collapseDuration = 200} = opts
    let elements = {}
    let context = this
    let icons = {
        collapsed: "",
        expanded: ""
    }
    let interval

    BaseConstructor.call(this)

    this.generate = () =>{
        if(title_options.text){
            generateTitle()
        }
        if(content_options.content){
            generateContent()
        }

        $(elements.title_container).on('click', e =>{
            if(e.target === elements.title_container || e.target === elements.c_icon || $(e.target).hasClass('fas')){
                context.collapse()
            }
        })

        return elements.container
    }

    this.setContent = content =>{
        $(elements.content_container).html(content)
    }

    this.appendContent = () =>{
        $(elements.content_container).append(content)
    }

    this.collapse = () =>{
        $(elements.container).removeClass('show').addClass('showing')
        
        setContentDisplay('block')

        is_open = !is_open

        this.move()

        updateIcon()
    }

    this.move = _ =>{
        
        const setWidth = height =>{
            elements.content_container.style.height = height + 'px'
        }

        var current_height = elements.content_container.clientHeight
        
        var height = elements.content_container.scrollHeight;

        if(interval){
            clearInterval(interval)
        }
        interval = setInterval(is_open ? open : close, 10);
        
        function open() {
            if (current_height >= height) {
                stop()
            } else {
                current_height += height / (collapseDuration/10);
                setWidth(current_height)
            }
        }

        function close() {
            if (current_height <= 0) {
                stop()
            } else {
                current_height -= height / (collapseDuration/10);
                setWidth(current_height)
            }
        }
        
    }

    function setContentDisplay(display){
        elements.content_container.style.display = display
    }

    function stop(){
        clearInterval(interval)
        if(is_open){
            elements.content_container.style.height = 'fit-content'
            $(elements.container).removeClass('showing').addClass('show')
        } else {
            elements.content_container.style.height = 0
            $(elements.container).removeClass('showing show')
            setContentDisplay('none')
        }
    }

    function updateIcon(){
        if(title_options.icon_options){
            $(elements.c_icon).html(is_open ? (title_options.icon_options.collapsed || '<i class="fas fa-chevron-up"></i>') : (title_options.icon_options.expanded || '<i class="fas fa-chevron-down"></i>'))
        }
    }

    function generateTitle(){
        elements.c_title = context.createElement('div', 'collapse-card-title-text')
        elements.right_container = context.createElement('div', 'collapse-card-title-right-container')
        elements.c_icon = context.createElement('div', 'collapse-card-title-icon')
        
        $(elements.c_title).html(title_options.text)

        updateIcon()

        if(title_options.additional_content){
            elements.title_additional_content_container = title_options.additional_content.content
            let position = title_options.additional_content.position
            if(position == 'right'){
                $(elements.right_container).append(elements.title_additional_content_container)
            }
        }

        $(elements.right_container).append(elements.c_icon)

        $(elements.title_container).append(elements.c_title, elements.right_container)

    }

    function generateContent(){
        $(elements.content_container).html(content_options.content)
    }
    
    init()
    function init(){
        elements.container = context.createElement('div', `collapse-card-container collapse ${is_open ? '' : 'show'}`)
        elements.title_container = context.createElement('div',`collapse-card-title-container ${title_options.customClass || ""}`)
        elements.content_container = context.createElement('div', `collapse-card-content-container ${content_options.customClass || ""}`)

        $(elements.container).append(elements.title_container,elements.content_container)

        stop()
    }

}

CollapseCard.prototype = Object.create(BaseConstructor.prototype)